import { MetricConverter } from './helpers';
import { ConvertArgs, UnitConverter } from './types';

export const ENERGY_VIEW_UNITS = ['kWh', 'MWh', 'GWh', 'Wh'] as const;
export const ENERGY_UNITS = [...ENERGY_VIEW_UNITS, 'J'] as const;

export const ENERGY_DEFAULT_UNIT = 'J' as const;
export const ENERGY_DEFAULT_VIEW_UNIT = 'kWh' as const;

type TEnergyUnit = (typeof ENERGY_UNITS)[number];

type ToBaseArgs = Parameters<UnitConverter<TEnergyUnit, 'J'>['toBase']>[0];

class EnergyConverter extends UnitConverter<TEnergyUnit, 'J'> {
    baseUnit = ENERGY_DEFAULT_UNIT;
    units = ENERGY_UNITS;

    defaultViewUnit = ENERGY_DEFAULT_VIEW_UNIT;

    getDisplayUnits() {
        return ENERGY_VIEW_UNITS;
    }

    toBase({ value, from }: ToBaseArgs) {
        return {
            value: from === 'J' ? value : this.convert({ value, from, to: 'J' }).value,
            unit: 'J' as const,
        };
    }

    convert<ToUnit extends TEnergyUnit>({ value, from, to }: ConvertArgs<TEnergyUnit, ToUnit>) {
        const whValue = from === 'J' ? value / 3600 : wattHourEnergyConverter.convert({ value, from, to: 'Wh' }).value;

        if (to === 'J') {
            return { value: whValue * 3600, unit: to };
        }

        return wattHourEnergyConverter.convert({ value: whValue, from: 'Wh', to });
    }
}

class WattHourEnergyConverter extends MetricConverter<TEnergyUnit, 'Wh'> {
    baseUnit = 'Wh' as const;
    units = ENERGY_VIEW_UNITS;
}

const wattHourEnergyConverter = new WattHourEnergyConverter();

export const energyConverter = new EnergyConverter();
